import { Dispatch } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import { AddressesActions } from '../addresses/addressesActions';
import { CardsActions } from './cards/cardsActions';
import PaymentMethods from './PaymentMethods';

function mapStateToProps({ addresses, cards, app }: IReduxRootState) {
    const showBillingAddress = app.presentationConfig.showSections['cards.billingAddress'] ?? true;
    const brandCodes = app.clientConfig.brandCodes;

    return {
        challengerPid: app.appConfig.CHALLENGER_ENABLED
            ? app.appConfig.CHALLENGER_PIDS.PAYMENTS
            : '',
        challengerPidDefault: app.appConfig.CHALLENGER_PIDS.PAYMENTS_DEFAULT,
        locale: app.locale,
        maxNumberOfCards: app.appConfig.MAX_NUMBER_OF_CARDS,
        addresses: addresses.addressesMap ? Object.values(addresses.addressesMap) : [],
        cards: cards.cardsMap ? Object.values(cards.cardsMap) : [],
        formOpen: cards.formOpen,
        loading: addresses.loading || cards.loading,
        showBillingAddress: showBillingAddress,
        brandCodes: brandCodes,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return {
        getCards: () => {
            dispatch(CardsActions.getCards());
            dispatch(AddressesActions.getAddresses());
        },
        closeOverlay: () => {
            dispatch(CardsActions.closeForm());
        },
        openOverlay: () => {
            dispatch(CardsActions.openForm());
        },
    };
}

const PaymentMethodsContainer = connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);

export default PaymentMethodsContainer;
